import { defineMessages } from 'react-intl'

const scope = `procurify.components.DepartmentSelect`

export default defineMessages({
  secondaryOrgCategorySelectLabel: {
    id: `${scope}.secondaryOrgCategorySelectLabel`,
    defaultMessage: '{singularSecondaryOrgCategoryLabel}',
  },
  secondaryOrgCategorySelectPlaceholder: {
    id: `${scope}.secondaryOrgCategorySelectPlaceholder`,
    defaultMessage: 'Select a {singularSecondaryOrgCategoryLabel}',
  },
})
